import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="custom-fields--validations"
export default class extends Controller {
  static targets = [
    "textValidations",
    "textareaValidations",
    "numberValidations",
  ];

  static values = {
    fieldType: String,
  };

  connect() {
    this.updateVisibility();
  }

  fieldTypeChanged(event) {
    this.fieldTypeValue = event.target.value;
    this.updateVisibility();
    this.clearValidations();
  }

  updateVisibility() {
    const fieldType = this.fieldTypeValue;

    // Hide all validation sections first
    this.hideAllSections();

    // Show relevant section based on field type
    switch (fieldType) {
      case "text":
      case "descriptive_number":
        this.showSection(this.textValidationsTarget);
        break;
      case "textarea":
        this.showSection(this.textareaValidationsTarget);
        break;
      case "number":
        this.showSection(this.numberValidationsTarget);
        break;
    }
  }

  hideAllSections() {
    if (this.hasTextValidationsTarget) {
      this.textValidationsTarget.classList.add("hidden");
    }
    if (this.hasTextareaValidationsTarget) {
      this.textareaValidationsTarget.classList.add("hidden");
    }
    if (this.hasNumberValidationsTarget) {
      this.numberValidationsTarget.classList.add("hidden");
    }
  }

  showSection(target) {
    if (target) {
      target.classList.remove("hidden");
    }
  }

  clearValidations() {
    // Clear all validation inputs when field type changes
    const inputs = this.element.querySelectorAll(
      'input[name^="custom_field[validations]"], select[name^="custom_field[validations]"]'
    );
    inputs.forEach((input) => {
      if (input.type === "checkbox") {
        input.checked = false;
      } else {
        input.value = "";
      }
    });
  }

  patternChanged(event) {
    const select = event.target;
    const patternInput = this.element.querySelector(
      'input[name="custom_field[validations][pattern]"]'
    );

    if (patternInput && select.value) {
      patternInput.value = select.value;
    } else if (patternInput) {
      patternInput.value = "";
    }
  }
}
